<template>
  <v-app id="inspire">
    <BaseConfirmDialog />
    <BaseSnackbar></BaseSnackbar>
    <BaseSnackbarNotAcceptable />
    <scroll v-if="!verifyAuth(me)">
      <div style="height: 100% !important;">
        <v-main style="height: 100% !important;">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-main>
      </div>
    </scroll>
    <Template v-else />
  </v-app>
</template>

<script>
import _ from "lodash";
import store from "./modules/auth/_store";
import BaseSnackbar from "./components/UI/BaseSnackbar";
import BaseSnackbarNotAcceptable from "./components/UI/BaseSnackbarNotAcceptable";
import BaseConfirmDialog from "./components/UI/BaseConfirmDialog.vue";
import Scroll from "./components/UI/BaseScroll.vue";
import Template from "./components/Template";
import { mapGetters } from "vuex";

export default {
  name: "App",

  components: {
    BaseSnackbar,
    BaseSnackbarNotAcceptable,
    Template,
    BaseConfirmDialog,
    Scroll
  },
  computed: {
    ...mapGetters({
      authenticated: "$_auth/authenticated",
      me: "$_auth/me"
    })
  },

  methods: {
    verifyCookie() {
      const pfo_chave = 'versionPFO'
      const pfo_version = process.env.VUE_APP_PFO_VERSION;

      let cookie = localStorage.getItem(pfo_chave);

      if(!cookie || cookie !== pfo_version) {
        localStorage.setItem(pfo_chave, pfo_version);
        window.location.reload();
      }
    },
    verifyAuth(me) {
      if (_.hasIn(me, "id") && !this.me.password_reset) return true;
      else return false;
    }
  },

  beforeCreate() {
    const lang = document.querySelector('html').getAttribute('lang')
    console.log('create',lang)
    const STORE_AUTH = "$_auth";
    if (!(STORE_AUTH in this.$store._modules.root._children))
      this.$store.registerModule(STORE_AUTH, store);
  },
  mounted() {
    this.verifyCookie();

    const lang = document.querySelector('html').getAttribute('lang')

    console.log('mounted',lang)
  },
};
</script>

<style lang="scss">
html {
  overflow: hidden;
  scroll-behavior: smooth;
}

body {
  background-color: #f1f1f1 !important;
}
.v-application {
  background-color: #f1f1f1 !important;
}

.v-expansion-panel-header__icon {
  order: -1;
  margin-right: 30px;
}
</style>
